var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.104 23.3789H3.68213C3.14755 23.3789 2.63487 23.1694 2.25687 22.7964C1.87886 22.4235 1.6665 21.9177 1.6665 21.3902V4.15538C1.6665 3.62797 1.87886 3.12215 2.25687 2.74921C2.63487 2.37626 3.14755 2.16675 3.68213 2.16675H26.5259C27.0605 2.16675 27.5731 2.37626 27.9511 2.74921C28.3291 3.12215 28.5415 3.62797 28.5415 4.15538V12.149",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 4.15538C1.6665 3.62797 1.87886 3.12215 2.25687 2.74921C2.63487 2.37626 3.14755 2.16675 3.68213 2.16675H26.5259C27.0605 2.16675 27.5731 2.37626 27.9511 2.74921C28.3291 3.12215 28.5415 3.62797 28.5415 4.15538V10.1213H1.6665V4.15538Z",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.354 6.14397C4.354 5.41177 4.95562 4.81821 5.69775 4.81821C6.43989 4.81821 7.0415 5.41177 7.0415 6.14397C7.0415 6.87616 6.43989 7.46973 5.69775 7.46973C4.95562 7.46973 4.354 6.87616 4.354 6.14397Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38525 6.14397C8.38525 5.41177 8.98687 4.81821 9.729 4.81821C10.4711 4.81821 11.0728 5.41177 11.0728 6.14397C11.0728 6.87616 10.4711 7.46973 9.729 7.46973C8.98687 7.46973 8.38525 6.87616 8.38525 6.14397Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8384 21.3904C24.9516 21.3904 25.854 20.5 25.854 19.4017C25.854 18.3034 24.9516 17.4131 23.8384 17.4131C22.7252 17.4131 21.8228 18.3034 21.8228 19.4017C21.8228 20.5 22.7252 21.3904 23.8384 21.3904Z",
    stroke: "white",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8385 24.0418V21.3903M23.8385 17.413V14.7615M19.7656 21.7217L22.093 20.3959M25.5841 18.4073L27.9114 17.0816M19.7656 17.0816L22.093 18.4073M25.5841 20.3959L27.9114 21.7217",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.78752036c6a746d01b0214f43efe04ad.svg";
export { ForwardRef as ReactComponent };